import React from 'react';
import { cn } from '@/lib/utils';
import { GOVERNANCE_COPY } from '@/lib/governanceCopy';

interface InstitutionalFooterProps {
  className?: string;
}

/**
 * InstitutionalFooter
 *
 * Single-line, low-contrast footer line displayed at the bottom of main
 * layouts. Reinforces the platform positioning ("SGPI · Governança
 * auditável") on every authenticated screen without adding visual noise.
 *
 * Does not display version strings, environment, build SHAs or any
 * technical metadata.
 */
export const InstitutionalFooter: React.FC<InstitutionalFooterProps> = ({ className }) => {
  const year = new Date().getFullYear();
  return (
    <footer
      aria-label="Rodapé institucional"
      className={cn(
        'hidden sm:flex items-center justify-center',
        'px-4 py-3 mt-4 border-t border-border/40',
        'text-[11px] tracking-wide text-muted-foreground/70',
        className,
      )}
    >
      <span>
        {GOVERNANCE_COPY.footer.line} · {year}
      </span>
    </footer>
  );
};

export default InstitutionalFooter;
